import { useMutation, useQueryClient, useQuery } from 'react-query'
import { getAnnouncements, getAnnouncementById, getAnnouncementDepartments, createAnnouncement, updateAnnouncement, deleteAnnouncement } from 'services/api/announcements'
import { retryProtectedQuery } from 'services/session/queryPolicy'

const retryAnnouncementQuery = (failureCount, error) =>
    retryProtectedQuery(failureCount, error, 1)

export const ANNOUNCEMENTS_QK = 'announcements'
export const ANNOUNCEMENT_DEPARTMENTS_QK = 'announcement-departments'

export const useGetAnnouncements = (page = 1, perPage = 12, options = {}) => {
    const { scopeKey = 'anonymous', ...queryOptions } = options

    return useQuery(
        [ANNOUNCEMENTS_QK, scopeKey, page, perPage],
        () => getAnnouncements(page, perPage),
        {
            staleTime: 300000,
            refetchOnWindowFocus: false,
            retry: retryAnnouncementQuery,
            keepPreviousData: true,
            ...queryOptions,
        }
    )
}

export const useGetAnnouncementById = (id, options = {}) => {
    return useQuery(
        [ANNOUNCEMENTS_QK, 'detail', id],
        () => getAnnouncementById(id),
        {
            enabled: !!id,
            staleTime: 300000,
            refetchOnWindowFocus: false,
            retry: retryAnnouncementQuery,
            ...options,
        }
    )
}

export const useGetAnnouncementDepartments = (options = {}) => {
    return useQuery(
        [ANNOUNCEMENT_DEPARTMENTS_QK],
        () => getAnnouncementDepartments(),
        {
            staleTime: 300000,
            refetchOnWindowFocus: false,
            retry: retryAnnouncementQuery,
            ...options,
        }
    )
}

export const useCreateAnnouncement = (options = {}) => {
    const qc = useQueryClient()

    return useMutation((payload) => createAnnouncement(payload), {
        onSuccess: (data) => {
            qc.invalidateQueries([ANNOUNCEMENTS_QK])
            options?.onSuccess?.(data)
        },
        onError: (error) => {
            options?.onError?.(error)
        },
    })
}

export const useUpdateAnnouncement = (options = {}) => {
    const qc = useQueryClient()

    return useMutation(({ id, ...payload }) => updateAnnouncement(id, payload), {
        onSuccess: (data) => {
            qc.invalidateQueries([ANNOUNCEMENTS_QK])
            options?.onSuccess?.(data)
        },
        onError: (error) => {
            options?.onError?.(error)
        },
    })
}

export const useDeleteAnnouncement = (options = {}) => {
    const qc = useQueryClient()

    return useMutation((id) => deleteAnnouncement(id), {
        onSuccess: (data) => {
            qc.invalidateQueries([ANNOUNCEMENTS_QK])
            options?.onSuccess?.(data)
        },
        onError: (error) => {
            options?.onError?.(error)
        },
    })
}
